import { t } from '../../i18n'
import {
  PackageTableCellCoverage,
  PackageTableCellTitle,
  PackageTableTypeText,
} from './styles'

type CoverageTitleProps = {
  isOptional: boolean
}

export const CoverageTitle = ({ isOptional }: CoverageTitleProps) => {
  return (
    <PackageTableCellCoverage whiteBackground>
      <PackageTableCellTitle>
        <PackageTableTypeText>
          {isOptional
            ? t('pages.step2.table.optionalCoverage')
            : t('pages.step2.table.baseCoverage')}
        </PackageTableTypeText>
      </PackageTableCellTitle>
    </PackageTableCellCoverage>
  )
}
